import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import BackButton from "../../../../../components/BackButton";
import CustomButton from "../../../../../components/CustomButton";
import { SectionLoader } from "../../../../../components/PageLoader";
import "./idealTalents.css";

const IdealTalents = () => {
  const history = useHistory();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [talents, setTalents] = useState([]);
  const [inviting, setInviting] = useState({});

  // Dummy data for UI demonstration
  const dummyTalents = [
    {
      id: 1,
      first_name: "John",
      last_name: "Doe",
      username: "johndoe",
      image_url: "https://via.placeholder.com/50",
      skills_match: 85,
    },
    {
      id: 2,
      first_name: "Jane",
      last_name: "Smith",
      username: "janesmith",
      image_url: "https://via.placeholder.com/50",
      skills_match: 92,
    },
    {
      id: 3,
      first_name: "Michael",
      last_name: "Johnson",
      username: "mjohnson",
      image_url: "https://via.placeholder.com/50",
      skills_match: 78,
    },
  ];

  useEffect(() => {
    // TODO: Fetch ideal talents from API
    // For now, using dummy data
    setTalents(dummyTalents);
  }, [id]);

  const handleInvite = async (talent) => {
    setInviting({ ...inviting, [talent.id]: true });
    
    // TODO: Call API to invite talent
    setTimeout(() => {
      setInviting({ ...inviting, [talent.id]: false });
      console.log("Invited talent:", talent);
    }, 1500);
  };

  const blurLastName = (lastName) => {
    if (!lastName) return "";
    return lastName.charAt(0) + "•".repeat(lastName.length - 1);
  };

  return (
    <div className="ideal-talents-container">
      {/* <div className="d-flex align-items-center mb-4">
        <BackButton handleClick={() => history.goBack()} />
        <h4 className="mb-0 ml-3">Invite Ideal Talents</h4>
      </div> */}

      <div className="talents-list">
        {loading && <SectionLoader />}
        
        {!loading && (!talents || talents.length === 0) && (
          <div className="d-flex align-items-center justify-content-center mb-3">
            <p className="text-center">No ideal talents found</p>
          </div>
        )}

        {!loading &&
          talents &&
          talents.length > 0 &&
          talents.map((talent) => (
            <div
              key={talent.id}
              className="talent-card d-flex align-items-center justify-content-between mb-3 p-3"
            >
              <span className="d-flex align-items-center">
                <img
                  width="50"
                  height="50"
                  src={talent.image_url}
                  alt="avatar"
                  className="rounded-circle"
                />
                <span className="d-flex flex-column ml-3">
                  <div className="d-flex align-items-center">
                    <h6 className="mb-0">
                      {talent.first_name} {blurLastName(talent.last_name)}
                    </h6>
                    {talent.skills_match !== undefined &&
                      talent.skills_match !== null && (
                        <span
                          className="px-2 py-1 small-text rounded ml-2"
                          style={{
                            backgroundColor: "#28a745",
                            color: "#fff",
                            fontSize: "0.7rem",
                            fontWeight: "bold",
                          }}
                        >
                          {typeof talent.skills_match === "number"
                            ? `${talent.skills_match}% Match`
                            : talent.skills_match}
                        </span>
                      )}
                  </div>
                  <span className="co-gray small-text">
                    @{talent.username}
                  </span>
                </span>
              </span>

              <CustomButton
                type="button"
                handleClick={() => handleInvite(talent)}
                disabled={inviting[talent.id]}
                backgroundColor="#3a6ed4"
                color="#fff"
                text="Invite"
                additionalClass="invite-btn"
                loading={inviting[talent.id]}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default IdealTalents;
